module.exports = __webpack_public_path__ + "static/media/55_000062.d3346164.jpg";